import {observer} from 'mobx-react-lite';
import React from 'react';

import {Props as DialogProps} from '#/Dialog/Dialog';
import Stepper from '#/Stepper';
import {TemplateWizardStep} from '_/store/template';

import {
  DialogContent,
  StyledCreateDocumentFromTemplate,
} from './CreateFromTemplateDialog.styles';

type Props = {
  className?: string;
  onClose: () => void;
  steps: {key: TemplateWizardStep | string; label: string}[];
  wizardStep: TemplateWizardStep | string;
  wizardScreens: {
    [key in TemplateWizardStep | string]: React.ReactElement | null;
  };
  dialogHeader: string;
};

const CreateFromTemplateDialogComponent = ({
  className,
  onClose,
  wizardStep,
  steps,
  wizardScreens,
  dialogHeader,
}: Props): React.ReactElement => {
  const dialogContent = (
    <DialogContent>
      <Stepper
        currentIndex={steps.map(({key}) => key).indexOf(wizardStep)}
        labels={steps.map(({label}) => label)}
      />
      {wizardScreens[wizardStep]}
    </DialogContent>
  );

  const dialogProps: React.PropsWithChildren<DialogProps> = {
    className,
    isShown: true,
    onClose,
    headerText: dialogHeader,
    testId: 'create-document-or-email-from-template',
    size: 'medium',
  };
  return (
    <StyledCreateDocumentFromTemplate {...dialogProps}>
      {dialogContent}
    </StyledCreateDocumentFromTemplate>
  );
};

export default observer(CreateFromTemplateDialogComponent);
